export const ACTION_GET_PURCHASERECONCILIATION = "ACTION_GET_PURCHASERECONCILIATION"
export const ACCION_GET_CHANGESTATE_LIST_TYPE_STATE = "ACCION_GET_CHANGESTATE_LIST_TYPE_STATE"
export const ACTION_POST_CHANGESTATE = "ACTION_POST_CHANGESTATE"